'use client';

import {thresolds} from '@/cst/utils';
import {cn} from '@/lib/utils';
import crypto from 'crypto';
import lzjs from 'lzjs';

import {RefObject, useEffect, useState} from 'react';

export default function Human({
  children,
  hash
}: React.PropsWithChildren<{hash: RefObject<string>}>) {
  const [isHuman, setIsHuman] = useState(false);
  const actions: {[key: string]: any[]} = {};
  const humanTime = 1000 * 60 * 3; // 3 minutes
  //const humanTime = 1000; // 1s
  const originalHash = `${hash.current}`;
  let t = setTimeout(() => {});
  const act = (type: string, a: any) => {
    if (!actions[type]) {
      actions[type] = [];
    }
    actions[type].push(a);
    const thresold = thresolds[type] ?? 100;
    if (actions[type].length > thresold) {
      actions[type].shift();
    } else {
      return;
    }
    if (!isHuman) {
      const cipher = crypto.createCipheriv(
        'aes-256-cbc',
        originalHash.substring(0, 32),
        originalHash.substring(0, 16)
      );
      let encrypted = cipher.update(lzjs.compress(JSON.stringify(actions)));
      encrypted = Buffer.concat([encrypted, cipher.final()]);

      hash.current = originalHash + '.' + encrypted.toString('hex');

      setIsHuman(true);
      clearTimeout(t);
      t = setTimeout(() => {
        setIsHuman(false);
      }, humanTime);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', (e) => {
      act('k', e.key); // get key press
    });

    window.addEventListener('scroll', (e) => {
      act('s', Math.floor(window.scrollY)); // get scroll position
    });

    document.addEventListener('click', (e) => {
      const element = e.target as HTMLElement; // get element
      if (['INPUT', 'SELECT', 'TEXTAREA'].includes(element.tagName)) {
        act('c', element.tagName); // record element
      }
    });

    document.addEventListener('mousemove', (e) => {
      act('m', e.clientX); // record mouse position
    });
  }, []);

  return (
    <span className={cn('grid')}>
      <div className={cn('row-start-1 col-start-1', !isHuman && 'opacity-50')}>
        {children}
      </div>
      {!isHuman && (
        <div className={cn('z-10 row-start-1 col-start-1 flex')}></div>
      )}
    </span>
  );
}
